<page-load-header *ngIf="!initialized"></page-load-header>

<h3>Closed Captions Servers</h3>
<div *ngIf="initialized" class="container-fluid">
  <ng-container *ngFor="let box of streamboxes">
    <bxl-caption-box [box]="box" [audioInputs]="audioInputs"></bxl-caption-box>
  </ng-container>

</div>
